"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piane-crati": {
    "d2984ae5": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "skipSearch": false
    }],
    "cannavali": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6b4340f9": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "skipSearch": false
    }],
    "chiuse": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "71b95506": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "skipSearch": false
    }],
    "giardino": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "df811343": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "skipSearch": false
    }],
    "marinello": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5c3c1ef0": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "skipSearch": false
    }],
    "rizzuso": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "48f78d3f": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "skipSearch": false
    }],
    "terzasirica": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c1230b5": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "skipSearch": false
    }],
    "valli": [{
      "hkey": "a4a4425d",
      "slug": "piane-crati",
      "name": "Piane Crati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;